<div>
  <app-alert
    style="margin-bottom: 32px"
    class="flex-col-container my-8"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="'MODAL_EXONERATION.ALERT' | translate"></app-alert>
  <p class="my-10">{{ 'MODAL_EXONERATION.ACCOUNT_TO_EXONERATE' | translate}}</p>

  <div class="p-16 flex-row-container items-center b-0-5 rounded">
    <img class="mr-8" src="assets/svg/account_exoneration.svg" alt="rappi logo" />
    <div class="flex-col-container start flex-1 ml-4">
      <span class="fw-500">{{ 'MODAL_EXONERATION.ACCOUNT_NUMBER' | translate}}</span>
      <span>{{account.external_number}}</span>
    </div>
    <app-read-only
      [descColor]="accountInfo?.is_gmf ? 'success' : 'warning'"
      [applyBorderBottom]="false"
      [value]="(accountInfo?.is_gmf ? 'BANKING_ACCOUNT.DETAIL.GMF_EXEMPTED' : 'BANKING_ACCOUNT.DETAIL.GMF_NOT_EXEMPTED') | translate"></app-read-only>
  </div>
</div>
